export const getTypeStyle = (type: string) => {
    switch (type) {
      case "ClockIn":
        return "text-green-600 bg-green-100";
      case "ClockOut":
        return "text-red-600 bg-red-100";
      case "BreakOut":
      case "LunchOut":
        return "text-yellow-700 bg-yellow-100";
      case "BreakIn":
      case "LunchIn":
        return "text-purple-600 bg-purple-100";
      default:
        return "text-gray-600 bg-gray-100";
    }
  };